import { Head, Link } from "@inertiajs/react"
import AppLogoIcon from "@/components/app-logo-icon"
import { CoffeeFlavorWheel } from "@/components/charts/CoffeeFlavorWheel"

export default function FlavorWheelPage() {
  return (
    <>
      <Head title="Rueda de Sabores SCA - Coffee Taster's Flavor Wheel" />

      <div className="bg-background min-h-screen">
        {/* Header */}
        <header className="bg-background/95 border-b backdrop-blur">
          <div className="container mx-auto flex h-14 items-center justify-between px-4">
            <Link href="/" className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-md">
                <AppLogoIcon className="h-8 w-8" />
              </div>
              <span className="font-semibold">Catador Pro</span>
            </Link>
            <Link
              href="/"
              className="bg-primary hover:bg-primary/90 inline-flex items-center rounded-md px-4 py-2 text-sm font-medium text-white transition-colors"
            >
              Comenzar a catar
            </Link>
          </div>
        </header>

        {/* Content */}
        <main className="container mx-auto max-w-5xl px-4 py-10">
          {/* Title */}
          <div className="mb-8 text-center">
            <h1 className="text-3xl font-bold tracking-tight">
              Rueda de Sabores del Catador de Cafe
            </h1>
            <p className="text-muted-foreground mx-auto mt-3 max-w-2xl text-lg">
              La herramienta estandar internacional para describir y comunicar
              las notas sensoriales del cafe, creada por la SCA, WCR y UC Davis.
            </p>
          </div>

          {/* Flavor Wheel */}
          <div className="mx-auto mb-12 h-[550px] w-full max-w-3xl rounded-xl border bg-white p-4">
            <CoffeeFlavorWheel />
          </div>

          {/* How to use it */}
          <div className="mx-auto max-w-3xl space-y-8">
            <h2 className="text-2xl font-bold">
              Como usar la Rueda de Sabores
            </h2>

            <div className="grid gap-6 md:grid-cols-3">
              <div className="rounded-xl border p-5">
                <div className="bg-primary/10 text-primary mb-3 flex h-10 w-10 items-center justify-center rounded-full text-lg font-bold">
                  1
                </div>
                <h3 className="mb-2 font-semibold">Empieza desde el centro</h3>
                <p className="text-muted-foreground text-sm">
                  El anillo interior contiene las categorias generales: Frutal,
                  Floral, Dulce, Nuez/Cacao, Especias, Tostado y mas. Identifica
                  la familia de sabores que percibes.
                </p>
              </div>

              <div className="rounded-xl border p-5">
                <div className="bg-primary/10 text-primary mb-3 flex h-10 w-10 items-center justify-center rounded-full text-lg font-bold">
                  2
                </div>
                <h3 className="mb-2 font-semibold">Navega hacia afuera</h3>
                <p className="text-muted-foreground text-sm">
                  El anillo medio desglosa cada categoria en subcategorias mas
                  especificas. Por ejemplo, "Frutal" se divide en Citricos,
                  Bayas, Fruta de Arbol, y Fruta Tropical.
                </p>
              </div>

              <div className="rounded-xl border p-5">
                <div className="bg-primary/10 text-primary mb-3 flex h-10 w-10 items-center justify-center rounded-full text-lg font-bold">
                  3
                </div>
                <h3 className="mb-2 font-semibold">
                  Identifica descriptores exactos
                </h3>
                <p className="text-muted-foreground text-sm">
                  El anillo exterior tiene los descriptores mas precisos: limon,
                  frambuesa, jazmin, chocolate oscuro, etc. Usa estos para
                  comunicar exactamente lo que percibes.
                </p>
              </div>
            </div>

            {/* Tips */}
            <div className="bg-primary/5 rounded-xl border p-6">
              <h3 className="mb-3 font-semibold">
                Consejos para mejorar tu paladar
              </h3>
              <ul className="text-muted-foreground space-y-2 text-sm">
                <li>
                  No te preocupes si no identificas sabores especificos al
                  principio. Empieza con las categorias generales del centro.
                </li>
                <li>
                  Practica con alimentos: prueba frutas, chocolate, especias y
                  flores para calibrar tu memoria sensorial.
                </li>
                <li>
                  Cata con otros. Compartir percepciones en grupo enriquece tu
                  vocabulario sensorial.
                </li>
                <li>
                  La rueda no es un examen. No hay respuestas incorrectas, solo
                  percepciones diferentes.
                </li>
              </ul>
            </div>

            {/* CTA */}
            <div className="py-6 text-center">
              <p className="text-muted-foreground mb-4 text-sm">
                Usa Catador Pro para registrar tus notas de catacion con la
                rueda de sabores integrada
              </p>
              <Link
                href="/"
                className="bg-primary hover:bg-primary/90 inline-flex items-center rounded-md px-6 py-3 text-sm font-medium text-white transition-colors"
              >
                Crear mi primera catacion
              </Link>
            </div>
          </div>

          {/* Footer */}
          <p className="text-muted-foreground mt-10 text-center text-xs">
            SCA/WCR/UC Davis Coffee Taster's Flavor Wheel v3 (2021). Visualizado
            con <span className="text-primary font-medium">Catador Pro</span>
          </p>
        </main>
      </div>
    </>
  )
}
